import React, { useEffect, useRef } from 'react';
import PrivacyPolicy, { PrivacyPolicyText } from '../../../../components/PrivacyPolicy';
import { isMobileOidc } from '../../../../utilities/oidc/oidc';
import { useRegisterComponent } from '../../../orchestrator';
import { CREATE_ACCOUNT_CONFIRMATION_PAGE_ID } from '../constants';
import { useCreateAccountConfirmationPageContext } from '../contexts/CreateAccountConfirmationPageContext';
import { useAppSelector } from '../../../../stores/redux.store';

export const CreateAccountConfirmationPrivacyPolicy = () => {
  useRegisterComponent(CreateAccountConfirmationPrivacyPolicy.name);

  const privacyPolicyMessageRef = useRef<HTMLParagraphElement>(null);

  const oidcContext = useAppSelector(state => state?.microbranding?.oidcContext);
  const isEmbedded = useAppSelector(state => Boolean(state.microbranding.isEmbedded));

  const { setPrivacyPolicyText } = useCreateAccountConfirmationPageContext();

  const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';

  useEffect(() => {
    if (privacyPolicyText) {
      setPrivacyPolicyText(privacyPolicyText);
    }
  }, [privacyPolicyText, setPrivacyPolicyText]);

  return (
    <PrivacyPolicy
      isEmbedded={isEmbedded}
      isMobileOidc={isMobileOidc(oidcContext)}
      pageId={CREATE_ACCOUNT_CONFIRMATION_PAGE_ID}
      privacyPolicyText={PrivacyPolicyText.oauthSignup}
      ref={privacyPolicyMessageRef}
    />
  );
};
